var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 43,
    fill: "none",
    viewBox: "0 0 39 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2306_173474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 1.346,
    d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_173474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.88 9.932a9.67 9.67 0 0 0-6.306 2.334 9.82 9.82 0 0 0-3.3 5.9 9.87 9.87 0 0 0 1.281 6.65 9.74 9.74 0 0 0 5.251 4.224c.49.09.663-.217.663-.476v-1.667c-2.716.596-3.289-1.318-3.289-1.318a2.62 2.62 0 0 0-1.08-1.438c-.877-.602.072-.602.072-.602a2.04 2.04 0 0 1 1.486 1.011 2.1 2.1 0 0 0 1.246 1.002 2.06 2.06 0 0 0 1.583-.183c.037-.495.249-.96.596-1.312-2.16-.247-4.428-1.09-4.428-4.815a3.8 3.8 0 0 1 .997-2.63 3.6 3.6 0 0 1 .096-2.594s.817-.264 2.673 1.005a9.1 9.1 0 0 1 4.87 0c1.855-1.27 2.667-1.005 2.667-1.005.358.814.4 1.733.12 2.576a3.8 3.8 0 0 1 .996 2.63c0 3.767-2.274 4.592-4.44 4.815a2.32 2.32 0 0 1 .662 1.805v2.69c0 .32.174.566.669.47a9.74 9.74 0 0 0 5.177-4.24 9.87 9.87 0 0 0 1.249-6.607 9.82 9.82 0 0 0-3.267-5.864 9.67 9.67 0 0 0-6.244-2.361",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_173474"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.904 9.687h19.614V29.3H9.904z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2306_173474",
    width: 38.403,
    height: 42.252,
    x: 0.434,
    y: 0.217,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2306_173474"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2306_173474",
    result: "shape"
  })))));
};
export default SvgGithub;